import { Component, OnInit } from '@angular/core';
import { HomepageService } from '@signature-it/ngx-generic/services';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { HomepageGroupLinksDTO } from '@signature-it/ngx-generic/models';

declare let _: any;

@Component({
    selector: 'groups-menu',
    templateUrl: './groups-menu.component.html',
    styleUrls: ['./groups-menu.component.scss'],
    standalone: false
})
export class GroupsMenuComponentGeneric implements OnInit {

    groupsMenuLinks: Array<Array<HomepageGroupLinksDTO>>;
    bgImg = GenericConfig.groupsMenuBgImg || '';

    constructor(protected homePageSvc: HomepageService) { }

    ngOnInit() {
        this.getHomePageGroupLinks();
    }

    getHomePageGroupLinks() {
        this.homePageSvc.getHomepageGroupLinks().subscribe(res => {
            if (res.data) {
                // each column contains 9 group links
                this.groupsMenuLinks = _.chunk(HomepageGroupLinksDTO.createFromArray(res.data), 9);
            }}, error => {}
        );
    }

}
